module.exports = __webpack_public_path__ + "assets/img/banner.27d98593.jpg";